import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { createDefaultFeature } from 'src/app/core/utilities/type-defaults.util';
import { Feature } from 'src/app/products/models/product.model';

@Component({
  standalone: true,
  selector: 'base-feature',
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.scss'],
  host: { ngSkipHydration: 'true' },
  imports: [
    CommonModule
  ]
})
export class FeatureComponent {

  /*   @Input() feature: Feature; */



  readonly featureInput = input<Feature>(createDefaultFeature());

  // Getters for backward compatibility
  get feature(): Feature {
    return this.featureInput();
  }
}


